
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cameras/[camera-name]",
      function () {
        return require("private-next-pages/cameras/[camera-name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cameras/[camera-name]"])
      });
    }
  